<template>
  <div class="page heightPage"
       style="overflow: auto">
    <div class="gzt_title">
      <el-page-header @back="goBack"> </el-page-header>
      日结项目名称：<el-input v-model="projectName"
                placeholder="请输入日结项目名称"
                style="width: 300px"
                maxlength="30"></el-input>
      <span style="margin-left: 15px">预计人员：{{ numberOfEstimate }}人</span>
      <!-- <span style="margin-left: 15px">预计金额：{{ estimateAmount }}元</span> -->
    </div>
    <div class="gzt_foundationBtn">
      <span style="text-decoration: underline; margin-right: 15px; cursor: pointer"
            @click="genMateResult = true">
        未激活小程序人数：<span style="color: red">{{ num }}</span></span>
      <el-button size="small "
                 type="success"
                 plain
                 @click="salaryCalculationDetail"
                 v-if="verifyPermission('Add')"
                 icon="el-icon-refresh-left">刷新</el-button>
      <el-dropdown style="margin: 0 10px"
                   trigger="hover"
                   v-if="verifyPermission('Add')"
                   @command="handleCommand">
        <el-button type="success"
                   size="small"
                   plain>
          人员录入<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown"
                          class="lang-select-dropdown">
          <el-dropdown-item command="applet">扫码录入</el-dropdown-item>
          <el-dropdown-item command="talentPool">人员库引入</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button
        size="small"
        type="primary"
        plain
        @click="openDialog('pages/home/dailyEntry', 1)"
        v-if="verifyPermission('Add')"
        icon="el-icon-plus"
        >查看人员录入小程序码</el-button
      > -->
      <el-button size="small "
                 type="primary"
                 plain
                 @click="
          openDialog('pages/managementDaily/manageList', 2),
            (dialogTitle = '项目人员管理 小程序码')
        "
                 v-if="verifyPermission('Add')"
                 icon="el-icon-eye">小程序人员管理</el-button>
      <!-- <el-button
        size="small "
        type="primary"
        plain
        @click="noticeDialogVisible = true"
        v-if="verifyPermission('Add') && type != 3"
        icon="el-icon-plus"
        >录入</el-button
      >
      <el-button
        size="small "
        type="primary"
        plain
        @click="add"
        v-if="verifyPermission('Add') && type != 3"
        icon="el-icon-plus"
        >新增</el-button
      > -->
      <el-button size="small "
                 type="danger"
                 plain
                 @click="del"
                 v-if="verifyPermission('Add')"
                 icon="el-icon-delete">删除</el-button>
    </div>
    <MyTable :tableData="tableData"
             :tableConfig="tableConfig"
             :height="tableHeight"
             :indexFlag="false"
             tableType="selection"
             @selectionChange="handleSelectionChange">
      <template v-slot:index="slotData">
        {{ slotData.scope.$index + 1 }}
      </template>
      <template v-for="item in tableConfig"
                v-slot:[item.slotName]="slotData">

        <el-input size="small"
                  :key="item.field"
                  v-model="slotData.scope.row[item.field]"></el-input>
      </template>
    </MyTable>
    <div class="gzt_functionBtn">
      <el-button @click="onSubmit(1)"
                 type="primary"
                 v-if="verifyPermission('Add')">保存</el-button>
      <!-- <el-button type="primary"
                 @click="onSubmit(2)"
                 v-if="verifyPermission('Add')">去校验</el-button> -->
    </div>
    <el-dialog title="去校验(请勾选需要合并的项)"
               :visible.sync="columnVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               :close-on-press-escape="false"
               width="440px">
      <el-form ref="columnFrom"
               :model="columnFrom"
               :rules="rules"
               label-width="auto"
               v-enterToNext="true">
        <!-- <el-form-item label="请选择需要汇总的列" prop="sumRowInt">
          <el-select
            v-model="columnFrom.sumRowInt"
            placeholder="请选择需要修改表头名称"
            filterable
            ref="batchSelect"
          >
            <el-option
              v-for="(item, i) in tableConfig"
              :key="item.field"
              :label="item.label"
              :value="i + 1"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <div style="text-align: center">
          <el-button type="primary" icon="el-icon-plus" circle></el-button>
        </div> -->
        <el-checkbox-group v-model="checkList">
          <el-checkbox style="width: 40%; margin-bottom: 10px"
                       v-for="(item, i) in tableConfig"
                       :key="item.field"
                       :label="i + 1">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              (columnFrom = {}), (columnVisible = false);
            }
          ">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   @click="check(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialogTitle"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :append-to-body="true"
               width="400px"
               center
               @close="closeDialog">
      <div style="display: flex; justify-content: center">
        <div>
          <div style="text-align: center">
            项目名称：<b>{{ projectName }}</b>
          </div>
          <img :src="imgPath"
               alt=""
               v-if="$shareType == 2" />
        </div>

        <div id="qrcode"
             ref="qrcode"
             v-if="$shareType == 1"></div>
      </div>
    </el-dialog>
    <el-dialog title="未激活小程序人员列表"
               :visible.sync="genMateResult"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :append-to-body="true"
               width="400px"
               center>
      <MyTable :tableData="generateData"
               :tableConfig="generateTableConfig"
               height="400px"
               :indexFlag="true">
        <template v-slot:index="slotData">
          <span class="label">
            {{ slotData.scope.$index + 1 }}
          </span>
        </template>
      </MyTable>
      <span slot="footer"
            class="dialog-footer">
        <div style="text-align: left; color: darkorange; margin-bottom: 5px">
          提示：列表中人员未激活小程序，请让列表中人员前往小程序进行授权激活，授权激活后，可点击下方按钮同步。
        </div>
        <!-- <el-button size="small " @click="genMateResult = false"
          >关 闭</el-button
        > -->
        <el-button size="small"
                   type="success"
                   plain
                   @click="synchronous"
                   v-if="verifyPermission('Add')"
                   icon="el-icon-refresh-left">同步人员信息</el-button>
      </span>
    </el-dialog>
    <notifyCard @colseDrawer="noticeDialogVisible = false"
                :visible.sync="noticeDialogVisible"
                @add="introduce"
                :filterate="tableData"
                importName="addTimesheet" />
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import notifyCard from "../purchaseInsurance/notifyCard.vue";

import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
export default {
  //import引入组件才能使用
  components: {
    MyTable,
    notifyCard,
  },
  props: {
    visible: Boolean,
    title: null,
    tableType: null,
    tableRowId: null,

  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  data () {
    return {
      tableHeight: "60vh",
      tableConfig: [],
      tableData: [],
      Ids: [],
      flag: 0,
      imgPath: "",
      hearderList: {},
      QRVisible: false,
      projectName: "",
      noticeDialogVisible: false,
      id: "",
      autoInt: "",
      estimateAmount: "",
      numberOfEstimate: "",
      checkList: [],
      salaryOriginalHeaderModel: "",
      genMateResult: false,
      generateTableConfig: [],
      generateData: [],
      headerId: "",
      columnVisible: false,
      columnFrom: {},
      type: "",
      rules: {},
      mainDetail: "",
      dialogTitle: "",
      num: 0,
      nameKey: "",
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {
    tableData (n, o) {
      this.generateData = [];
      this.num = 0;
      this.tableData.forEach((item) => {
        if (!item.userOpenId) {
          this.num++;
          this.generateData.push(item);
        }
      });
      console.log(this.num);
    },
  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted () {
    this.type = this.$route.query.type ? this.$route.query.type : this.tableType;
    this.id = this.$route.query.id ? this.$route.query.id : this.tableRowId;
    this.salaryCalculationDetail();
    this.SalaryCalculateMainDetail();
  },
  // 方法集合
  methods: {
    // 同步
    synchronous () {
      if (this.tableData.length <= 0) {
        this.$message.warning("不存在未激活人员，无需操作");
        return;
      }
      let idList = [];
      this.tableData.forEach((item) => {
        if (!item.userOpenId) {
          idList.push(item.userId);
        }
      });
      this.$api.user.RequestUserOpenId(idList).then((res) => {
        if (res.error === false) {
          res.data.forEach((item) => {
            this.tableData.forEach((v) => {
              if (item.id == v.userId) {
                this.$set(v, "userOpenId", item.openId);
                return;
              }
            });
          });
          this.SalarySheetAdd(1, true);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCommand (value) {
      if (value == "applet") {
        this.dialogTitle = "人员录入 小程序码";
        this.openDialog("pages/home/dailyEntry", 1);
      } else if (value == "talentPool") {
        this.noticeDialogVisible = true;
      }
    },
    // 重新处理对象
    objectOrder (obj) {
      //排序的函数

      var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组，这行是最重要的代码！

      var newObj = {}; //创建一个新的对象，用于存放排好序的键值对

      for (var i = 0; i < newkey.length; i++) {
        //遍历newkey数组

        newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
      }

      return newObj; //返回排好序的新对象
    },
    delKey (obj) {
      delete obj.autoInt;
      delete obj.companyId;
      delete obj.id;
      delete obj.salaryId;
    },
    SalaryCalculateMainDetail () {
      let sendData = {
        id: this.id,
      };
      this.$api.salary.SalaryCalculateMainDetail(sendData).then((res) => {
        if (res.error === false) {
          this.autoInt = res.data.autoInt;
          this.estimateAmount = res.data.estimateAmount;
          this.numberOfEstimate = res.data.numberOfEstimate;
          this.projectName = res.data.projectName;
          this.mainDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    closeDialog () { },
    // 打开并生成小程序码
    openDialog (url, type) {
      this.QRVisible = true;
      if (this.mainDetail.projectEnterCode && type == 1) {
        this.imgPath = this.mainDetail.projectEnterCode;
        this.QRVisible = true;
        return;
      }
      if (this.mainDetail.projectCode && type == 2) {
        this.imgPath = this.mainDetail.projectCode;
        this.QRVisible = true;
        return;
      }

      this.$nextTick(() => {
        this.qrcode(url, type);
      });
    },
    //生成微信小程序码
    qrcode (url, type) {
      if (this.$shareType == 2) {
        this.submitLoading = true;
        let sendData = {
          page: url,
          check_path: false,
          width: 150,
          scene: this.autoInt,
        };
        this.GetUnlimitedQRCode(sendData).then((res) => {
          this.imgPath = "data:image/png;base64," + res;

          this.SalaryEdit(this.imgPath, type);
          this.submitLoading = false;
          this.QRVisible = true;
        });
      }
    },
    check (type) {
      //去校验
      if (type == 2) {
        if (this.checkList.length <= 0) {
          this.$message.warning("请勾选合并项！");
          return;
        }
        this.SalarySheetAdd(type);
      } else {
        this.SalarySheetAdd(type);
      }
    },
    //获取数据
    salaryCalculationDetail () {
      this.loading = true;
      let sendData = {};
      sendData = {
        pageIndex: 1,
        pageSize: 99999,
        salaryId: this.id,
      };
      this.$api.salary.OriginalDatePage(sendData).then((res) => {
        if (!res.error) {

          this.tableConfig = [];
          this.salaryOriginalHeaderModel = res.data.salaryOriginalHeaderModel;
          this.hearderList = res.data.salaryOriginalHeaderModel;
          this.delKey(this.salaryOriginalHeaderModel);

          for (var i in this.objectOrder(res.data.salaryOriginalHeaderModel)) {
            if (
              i.indexOf("cell") != -1 &&
              res.data.salaryOriginalHeaderModel[i] != null
            ) {
              if (res.data.salaryOriginalHeaderModel[i] == "姓名") {
                this.generateTableConfig = [];
                this.generateTableConfig.push({
                  field: i,
                  label: res.data.salaryOriginalHeaderModel[i],
                  minWidth: "120",
                  align: "center",
                  flag: true,
                });
              }
              this.tableConfig.push({
                field: i,
                label: res.data.salaryOriginalHeaderModel[i],
                minWidth: "120",
                align: "center",
                slotName: res.data.salaryOriginalHeaderModel[i],
                flag: true,
              });
            }
          }
          this.tableData = res.data.salaryOriginalDatumPage.data
            ? res.data.salaryOriginalDatumPage.data
            : [];
          this.tableData &&
            this.tableData.forEach((item) => {
              this.delKey(item);
            });
          this.total = res.data.salaryOriginalDatumPage.count;

          this.loading = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    introduce (value) {
      let userList = [];
      value.forEach((element) => {
        let obj = {};
        obj.userId = element.userId;
        obj.name = element.cname;
        obj.tel = element.tel;
        obj.identityCard = element.identityCard;
        obj.openId = element.openId;
        obj.bankNo = element.defaultBankNo;
        obj.bankName = element.defaultBankName;
        userList.push(obj);
      });
      let sendData = {
        header: this.hearderList,
        userList: userList,
      };
      this.$api.salary.SalaryIntroduceUserData(sendData).then((res) => {
        if (res.error === false) {
          //console.log(res.data);
          this.tableData.push.apply(this.tableData, res.data);
          this.SalarySheetAdd(1, false, false);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //返回
    goBack () {
      if (this.tableRowId) {

        this.$emit("close")

      } else {
        this.$router.push("/salaryCalculationList");

      }
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        if (v.userId) {
          return v.index;
        } else {
          return v.flag;
        }
      });
      console.log(this.Ids);
    },
    //新增
    add () {
      this.flag = this.flag + 1;
      console.log(this.flag);
      this.tableData.push({ flag: this.flag });
    },
    del () {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.Ids.forEach((v) => {
        this.tableData.forEach((item, i) => {
          if (item.flag == v || item.index == v) {
            this.tableData.splice(i, 1);
          }
        });
      });
    },
    changeState (id) {
      let sendData = {
        salaryId: id,
        state: 4,
      };
      this.$api.salary.UpdateCalculateState(sendData).then((res) => {
        if (res.code == 0) {
          this.$router.replace("/salaryCalculationDetail?id=" + id);

          // this.$router.push({
          //   path: "/salaryCalculationDetail",
          //   query: {
          //     name: row.projectName,
          //     id: row.id,
          //     calculateState: row.calculateState,
          //     time: row.createDate,
          //     salaryHeaderMainId: row.salaryHeaderMainId,
          //   },
          // });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //编辑主表
    SalaryEdit (path, type) {
      let sendData = {
        projectName: this.projectName,
        numberOfEstimate: this.numberOfEstimate,
        estimateAmount: this.estimateAmount,
        projectCode: type == 2 ? path : this.mainDetail.projectCode,
        projectEnterCode: type == 1 ? path : this.mainDetail.projectEnterCode,
      };
      if (this.id) {
        sendData.id = this.id;
      }
      this.$api.salary.SalaryEdit(sendData).then((res) => {
        // console.log(res);
        if (res.error === false) {
          this.SalaryCalculateMainDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //保存
    SalarySheetAdd (type, falg, tip) {
      let sendData = {
        type: 1,
        projectName: this.projectName,
        header: this.salaryOriginalHeaderModel,
        dataList: this.tableData,
        headerId: this.headerId,
        isTS: type == 1 ? true : false,
      };
      if (this.id) {
        sendData.id = this.id;
        delete sendData.headerId;
      }
      this.$api.salary.SalarySheetAdd(sendData).then((res) => {
        // console.log(res);
        if (res.error === false) {
          if (type == 1) {
            this.SalaryEdit();
            if (falg) {
              this.$message.success("小程序激活信息已同步");
              this.num = 0;
              this.generateData = [];

              this.tableData.forEach((item) => {
                if (!item.userOpenId) {
                  this.generateData.push(item);
                  this.num++;
                }
              });
            } else {
              if (tip) {
                this.$message.success("保存成功");
              }
              //this.$router.replace("/salaryCalculationList");
            }
          } else {
            //this.$message.success("保存成功");
            this.changeState(res.data);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit (type) {
      if (this.tableData.length <= 0 && type == 2) {
        this.$message.warning("无人员数据！");
        return;
      }
      if (this.projectName.length <= 0) {
        this.$message.warning("请输入项目名称！");
        return;
      }
      if (type == 2 && this.num > 0) {
        this.$confirm(
          "存在未激活小程序人员，将影响该人员的微信发放！",
          "提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "继续下一步",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.SalarySheetAdd(type);
          })
          .catch((val) => {
            if (val == "cancel") {
              //this.synchronous();
            }
          });
      } else {
        this.SalarySheetAdd(type, null, true);
      }
    },
  },
};
</script>
<style scoped lang="less">
.el-dialog .el-dialog__body {
  padding: 15px 25px !important;
}
.gzt_title {
  text-align: center;
  // font-size: 22px;
}
.gzt_foundationBtn {
  float: right;
  margin-bottom: 15px;
}
.gzt_functionBtn {
  text-align: center;
  margin-top: 20px;
}
</style>

